'use client'

import {
  AspectRatio,
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Image,
  Img,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { FaChevronDown } from 'react-icons/fa'
import { useEffect, useState } from 'react'
import { authService } from '../FBase'
import { useQuery } from '@tanstack/react-query'
import { getUser } from '../api'
import path from 'path'
import { Link } from 'react-router-dom'
import { GiHamburgerMenu } from 'react-icons/gi'

interface IGoogleUser {
  name: string
  avatar: string
  email: string
  displayName: string
  photoURL: string
  uid: string
}

export default function Header() {
  const [init, setInit] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [user, setUser] = useState<IGoogleUser | null>(null)

  const { isOpen, onOpen, onClose } = useDisclosure()

  // 🗺 멤버 정보 가져오기
  const { isLoading: userLoading, data: userInfo } = useQuery({
    queryKey: ['userInfo', user?.uid],
    queryFn: getUser,
    enabled: !!user?.uid, // user.uid가 존재할 때만 쿼리 실행
  })

  // 유저를 가지고 있는지 확인하는 역할
  useEffect(() => {
    authService.onAuthStateChanged((data: any) => {
      if (data) {
        // 이메일을 가지고 있다면 로그인
        if (data.email !== null) {
          setIsLoggedIn(true)
          console.log('isLoggedIn:', isLoggedIn)
        }
        // 이메일을 가지고 있지 않다면 로그아웃
        else {
          setIsLoggedIn(false)
        }
        setUser(data)
        setInit(true)
      } else {
        setIsLoggedIn(false)
        setInit(true)
      }
    })
  }, [])

  // 로그아웃 함수
  const onLogOutClick = () => {
    authService.signOut()
    // 로그아웃 후 홈으로 이동
    window.location.href = '/'
  }

  // 모바일 메뉴 아이템 컴포넌트
  const MobileNavItem = ({ label, href }: { label: string; href: string }) => {
    return (
      <Link to={href}>
        <Box
          py={3}
          px={4}
          _hover={{
            bg: 'gray.50',
          }}
          onClick={onClose}>
          <Text fontWeight="medium">{label}</Text>
        </Box>
      </Link>
    )
  }

  // 모바일 메뉴 섹션 컴포넌트
  const MobileNavSection = ({
    title,
    children,
  }: {
    title: string
    children: React.ReactNode
  }) => {
    return (
      <Box py={2}>
        <Text
          px={4}
          py={2}
          fontSize="sm"
          fontWeight="semibold"
          color="gray.600"
          textTransform="uppercase">
          {title}
        </Text>
        <VStack
          align="stretch"
          spacing={0}>
          {children}
        </VStack>
      </Box>
    )
  }

  return (
    <Box backgroundColor={'#00236e'}>
      <HStack
        h={'14'}
        px={8}
        borderBottomWidth={1}
        justifyContent={'space-between'}>
        <Link to="/">
          <Text
            color={'white'}
            fontSize={'2xl'}
            fontWeight={'bold'}>
            TaxCoach
          </Text>
        </Link>
        <Flex
          gap={12}
          display={{ base: 'none', md: 'flex' }}>
          <Link
            to="/familyAge"
            style={{ color: 'white' }}>
            가족 나이 계산기
          </Link>
          <Link
            to="/businessTaxCalculator"
            style={{ color: 'white' }}>
            세금 계산기
          </Link>

          <Menu autoSelect={false}>
            <MenuButton _hover={{ color: 'blue' }}>
              <Flex
                color={'white'}
                align={'center'}
                justify={'center'}
                gap={1}>
                돈과 시간 <FaChevronDown />
              </Flex>
            </MenuButton>
            <MenuList
              minW={'150px'}
              maxW={'300px'}>
              <Link to="/moneyTime">
                <MenuItem justifyContent={'center'}>돈의 시간가치</MenuItem>
              </Link>
              <MenuDivider />
              <Link to="/timePower">
                <MenuItem justifyContent={'center'}>시간의 힘</MenuItem>
              </Link>
              <MenuDivider />
              <Link to="/moneyTimeResult">
                <MenuItem justifyContent={'center'}>목적 자금계산</MenuItem>
              </Link>
            </MenuList>
          </Menu>
          <Menu autoSelect={false}>
            <MenuButton _hover={{ color: 'blue' }}>
              <Flex
                color={'white'}
                align={'center'}
                justify={'center'}
                gap={1}>
                보고서 <FaChevronDown />
              </Flex>
            </MenuButton>
            <MenuList
              minW={'150px'}
              maxW={'300px'}>
              <Link to="/lifeCyle">
                <MenuItem justifyContent={'center'}>LifeCyle 보고서</MenuItem>
              </Link>
              <MenuDivider />
              <Link to="/oecdTable">
                <MenuItem justifyContent={'center'}>국가별 경제준비표</MenuItem>
              </Link>
              <MenuDivider />
              <Link to="/financeReport">
                <MenuItem justifyContent={'center'}>개인 재무제표</MenuItem>
              </Link>
            </MenuList>
          </Menu>
        </Flex>
        {/* 모바일 햄버거 버튼 */}
        <IconButton
          display={{ base: 'flex', md: 'none' }}
          aria-label="Open menu"
          variant="ghost"
          color="white"
          icon={<GiHamburgerMenu size={28} />}
          onClick={onOpen}
          _hover={{ bg: 'whiteAlpha.200' }}
          h={'12'}
          w={'12'}
        />

        {/* 모바일 드로어 메뉴 */}
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={onClose}
          size="sm">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader
              h={'14'}
              borderBottomWidth="1px"
              bg="#00236e"
              color="white">
              <Flex
                h="100%"
                justify="space-between"
                align="center">
                <Text
                  fontSize={'2xl'}
                  fontWeight={'bold'}>
                  TaxCoach
                </Text>
                <DrawerCloseButton
                  size={'lg'} // 크기 증가
                  color="white"
                />
              </Flex>
            </DrawerHeader>
            <DrawerBody p={0}>
              <MobileNavSection title="금융 계산기">
                <Divider
                  borderBottomWidth={2}
                  borderColor="grey"
                />
                <MobileNavItem
                  label="가족 나이 계산기"
                  href="/familyAge"
                />
                <MobileNavItem
                  label="세금 계산기"
                  href="/businessTaxCalculator"
                />
              </MobileNavSection>

              <MobileNavSection title="돈과 시간">
                <Divider
                  borderBottomWidth={2}
                  borderColor="grey"
                />
                <MobileNavItem
                  label="돈의 시간가치"
                  href="/moneyTime"
                />
                <MobileNavItem
                  label="시간의 힘"
                  href="/timePower"
                />
                <MobileNavItem
                  label="목적 자금계산"
                  href="/moneyTimeResult"
                />
              </MobileNavSection>

              <MobileNavSection title="보고서">
                <Divider
                  borderBottomWidth={2}
                  borderColor="grey"
                />
                <MobileNavItem
                  label="LifeCyle 보고서"
                  href="/lifeCyle"
                />
                <MobileNavItem
                  label="국가별 경제준비표"
                  href="/oecdTable"
                />
                <MobileNavItem
                  label="개인 재무제표"
                  href="/financeReport"
                />
              </MobileNavSection>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        {/* 로그인 버튼들 */}
        {/* <Flex gap={2}>
          {!isLoggedIn ? (
            <Button
              variant={'outline'}
              backgroundColor={'primary'}
              color={'white'}>
              <Link to="/login">로그인</Link>
            </Button>
          ) : (
            <Menu autoSelect={false}>
              <MenuButton>
                <Avatar
                  size={'md'}
                  name={user?.email}
                  src={user?.photoURL}
                />
              </MenuButton>
              <MenuList sx={{ minWidth: '80px', width: '100px' }}>
                <Link to="/myPage">
                  <MenuItem>마이 페이지</MenuItem>
                  <MenuDivider />
                </Link>
                <MenuItem onClick={onLogOutClick}>Log out</MenuItem>
              </MenuList>
            </Menu>
          )}
        </Flex> */}
      </HStack>
    </Box>
  )
}
